module.exports = __webpack_public_path__ + "static/media/template3.93be47ca.png";